import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {size, center, className, overlay} = self.get();

const classNameObj = {
    'k-spin': true,
    [`k-${size}`]: size !== 'default',
    'k-center': !overlay && center,
    [className]: className,
    'k-overlay': overlay,
};

const canvas = (
    h('div', null, (_blocks['canvas'] = function(parent) {
        return h('svg', {
            'viewBox': '0 0 120 120'
        }, h('circle', {
            'cx': '60',
            'cy': '60',
            'r': '57'
        }, null, 'k-circle'));
    }) && (__blocks['canvas'] = function(parent) {
        var args = arguments;
        return blocks['canvas'] ? blocks['canvas'].apply($this, [function() {
            return _blocks['canvas'].apply($this, args);
        }].concat(__slice.call(args, 1))) : _blocks['canvas'].apply($this, args);
    }) && __blocks['canvas'].apply($this, [__noop]), 'k-canvas')
);

    return h(Animate, {
        'className': _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)),
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'a:transition': 'c-fade',
        'children': function() {try {return (overlay )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, function() {try {return (canvas )} catch(e) {_e(e)}}.call($this), 'k-wrapper') :
            function() {try {return (canvas )} catch(e) {_e(e)}}.call($this),
        '_context': $this
    })
}